export default function usePayTicketMutation(payload) {
    const {
        bearerToken,
        centerUid,
        searchTerm,
        searchTermType,
        onSuccessCallback,
        onErrorCallback
    } = payload

    const headers = {
        Authorization: `Bearer ${bearerToken}`
    }

    const apiUrl = `/api/parking/centers/${centerUid}/tickets/search/${searchTermType}/${searchTerm}`
    const mutationKey = ['payTicket', searchTerm]

    return useTanstackMutation({
        mutationKey,
        apiUrl,
        headers,
        method: 'POST',
        onSuccessCallback,
        onErrorCallback,
    })
}
